<template>
    <div class="SuccessfulCases">
        <RouteHeadAndCrumbs
            :backgroundImg="backgroundImg"
            :breadcrumbsInfo="breadcrumbsInfo"
        />
        <div
            class="successfulCases-main-container"
            :style="`background:url(${middleBgImg}) no-repeat;background-size:cover;`"
        >
            <div class="shade-container" />
            <div class="successfulCases-content-container">
                <Partners :titleText="'他们都选择了我们'" :titleSubText="'They all chose us'" />
            </div>
        </div>
    </div>
</template>

<script>
import headImg from "../assets/images/65.png";

import { ROUTEINFO } from "../utils/constant";

import successfulMiddleImg from "../assets/images/5988636.jpg";

import Partners from "../components/Home/Partners";

export default {
    components: {
        Partners,
    },
    data() {
        return {
            backgroundImg: headImg,
            breadcrumbsInfo: [
                {
                    routeName: ROUTEINFO.home.name,
                    routeLabel: "首页",
                    routeTo: {
                        path: ROUTEINFO.home.path,
                    },
                },
                {
                    routeName: ROUTEINFO.successfulCases.name,
                    routeLabel: "成功案例",
                },
            ],
            middleBgImg: successfulMiddleImg,
        };
    },
};
</script>

<style lang="scss">
@import "../assets/scss/views/SuccessfulCases.scss";
</style>
